import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AnnouncementApiService } from '../services/api/announcement-api.service';
import { Announcement, IAnnouncement } from '../types/website-builder/announcement';
import { of } from 'rxjs/observable/of';

@Injectable()
export class AnnouncementResolver implements Resolve<Observable<IAnnouncement>> {
    constructor(
        private announcementApi: AnnouncementApiService,
    ) {}

    /**
     * Resolves number of resident patches
     *
     * for building ID
     */
    resolve(route: ActivatedRouteSnapshot): Observable<IAnnouncement> {
        return route.params.noticeId ? this.announcementApi.getNotice(route.params.noticeId) : of(new Announcement());
    }
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/announcement.resolver.ts